// extracted by mini-css-extract-plugin
export var completionBody = "_jc-2";
export var completionCard = "_jc-0";
export var completionFooter = "_jc-3";
export var completionTitle = "_jc-1";